import React, { Component } from 'react';

export default class Head extends Component {
	
	state ={hover:false, clicked: false}

	render() {

		const shadows = {
			normal: "0 2px 2px rgba(0, 0, 0, 0.2)", 
			hover: "0 2px 8px rgba(0, 0, 0, 0.4)",
			clicked: "0 8px 16px rgba(0, 0, 0, 0.4)"
		} ;

		return [
			
			<img src={require('./img/DanArielyLabs.png')} style={{
				position:"absolute",
				left: 24,
				top: 32,
				width:32,
				height:32 * (264/294)
			}} />,
			<div style={{
				position:"absolute",
				left: 24,
				right: 24,
				top: 80,				
				fontSize:24,
			}}>
				<p style={{fontWeight:"bold"}}>
					Simulation completed.
				</p>
				<p style={{fontSize:16}}>
					Thank you very much for your participation.
				</p>
			</div> ,

			// <div style={{
			// 	position:"absolute",
			// 	zIndex:12,
			// 	right: 127,
			// 	top: 350,			
			// 	padding: "12px 16px 12px 16px",
			// 	borderRadius: 2,
			// 	backgroundColor: this.state.clicked ? global.verylightblue : this.state.hover ? global.lightblue : global.blue,
			// 	display:"flex",
			// 	justifyContent:"center",
			// 	alignItems:"center",
            //     cursor:"pointer",
			// 	boxShadow: this.state.clicked ? shadows.clicked : this.state.hover ?  shadows.hover :  shadows.normal,
			// 	transition:"all 0.2s ease-out",
			// }} 
			// onMouseEnter={() => {
			// 	this.setState({hover:true})
			// }} onMouseLeave={() => {
			// 	this.setState({hover:false, clicked:false})
			// }} onMouseDown={()=>{
			// 	this.setState({clicked:true, hover:false})
			// }} onMouseUp={()=>{
			// 	this.setState({clicked:false, hover:false})
			// }}
			// onTouchCancel={() => {
			// 	this.setState({clicked:false})
			// }} onTouchStart={()=>{
			// 	this.setState({clicked:true})
			// }} onTouchEnd={()=>{			
			// 	this.setState({clicked:false})
			// }}
			// onClick={() => {
			// 	window.location = `#${global.groupName}/0`
			// 	global._dataSent = false
			// }}>
			// 	<span style={{
			// 		color:"white",
			// 		fontWeight:500,
			// 		fontSize:16,
			// 		letterSpacing: 1.2,
			// 		textTransform: "uppercase",
			// 	}}>restart</span>
			// </div>

		]
	}

}



// WEBPACK FOOTER //
// ./src/Comp/Done.js